<template>
  <v-card flat width="100%">
    <v-card-title>Suburbs</v-card-title>
    <v-card-text>
      <v-col cols="12">
        <select-suburbs
          :outlined="outlined"
          :clear="clear"
          v-model="suburb"
        ></select-suburbs>
        <v-chip
          @click:close="deleteSuburb(suburb)"
          class="mr-1"
          close
          v-for="(suburb, index) in data"
          :key="index"
        >
          {{ suburb }}
        </v-chip>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import SelectSuburbs from './SelectSuburbs'

export default {
  props: {
    value: {
      default() {
        return []
      }
    },
    outlined: { default: false }
  },
  components: {
    SelectSuburbs
  },
  data() {
    return {
      suburb: '',
      data: [],
      clear: true
    }
  },
  watch: {
    suburb(value) {
      if (value) {
        if (!this.data.includes(value)) {
          this.data.push(value)
        }
        this.suburb = '' // Reset suburb to an empty string after processing
        this.clear = !this.clear
      }
    },
    data: function(value) {
      this.$emit('input', value)
    },
    value: function(value) {
      console.log(value, typeof value)
      this.data = value
    }
  },
  methods: {
    deleteSuburb(suburb) {
      this.data = this.data.filter(i => i !== suburb)
      this.clear = !this.clear 
    }
  }
}
</script>

<style></style>
